import { PaginationPresentationProps } from "@insite/mobius/Pagination";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, ELEMENTS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

const P = ELEMENTS.pagination as any;

/** Shared MGBW pagination presentation props, reusable across PLP and My Account. */
export function getMgbwPaginationOverrides(): PaginationPresentationProps {
    return {
        ...(P.labelFontWeight ? {
            selectProps: {
                labelProps: {
                    weight: Number(P.labelFontWeight),
                },
            },
        } : {}),
        cssOverrides: {
            perPageSelect: css`
                label {
                    font-style: normal;
                    font-weight: ${P.labelFontWeight || TYPOGRAPHY.weight.base} !important;
                    font-size: ${TYPOGRAPHY.size.small};
                    line-height: ${TYPOGRAPHY.lineHeight.xbase};
                    color: ${COLORS.lightBlack};
                    padding: 2px 15px 0 0;
                }
                > div[class^="FormInputWrapper"] {
                    max-width: 65px;
                }
                select {
                    /* Beats the brand-wide select height applied in Start.tsx. */
                    height: 28px !important;
                    padding: 0 10px !important;
                }
                span {
                    top: -3px !important;
                    padding: 0 8px !important;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`width: auto;`,
                        css`width: auto;`,
                        css`width: auto;`,
                        null,
                        null,
                    ])}
            `,
            linkList: css`
                ${P.gap ? `
                    ul {
                        gap: ${P.gap};
                        display: flex;
                        align-items: center;
                    }
                ` : ""}
                li {
                    button {
                        width: fit-content;
                        padding: ${ELEMENTS.pagination.padding};
                        min-height: ${ELEMENTS.pagination.minHeight};
                        ${P.buttonBorder ? `border: ${P.buttonBorder};` : ""}
                        ${P.buttonBackground ? `background: ${P.buttonBackground};` : ""}
                        span {
                            font-style: normal;
                            font-weight: 400;
                            font-size: ${ELEMENTS.pagination.size};
                            line-height: 24px;
                            color: ${P.pageColor || COLORS.dark};
                        }
                    }
                }
                ${P.hideFirstLast === "true" ? `
                    li:first-child,
                    li:last-child {
                        display: none;
                    }
                ` : ""}
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`width: auto;`,
                        css`width: auto;`,
                        css`width: auto;`,
                        null,
                        null,
                    ])}
            `,
            currentButton: css`
                min-height: ${P.activeSize || "24px"} !important;
                ${P.activeSize ? `
                    width: ${P.activeSize} !important;
                    height: ${P.activeSize};
                    display: flex;
                    align-items: center;
                    justify-content: center;
                ` : ""}
                ${P.activeBorderRadius ? `border-radius: ${P.activeBorderRadius} !important;` : ""}
                ${P.activeBackground ? `
                    background: ${P.activeBackground} !important;
                    border-color: ${P.activeBackground} !important;
                ` : ""}
                span {
                    color: ${P.activeColor || getColor("primary.contrast")} !important;
                    ${P.activeSize ? "font-weight: 500;" : ""}
                }
                ${P.activeBackground ? `
                    &:hover {
                        background: ${P.activeBackground} !important;
                        border-color: ${P.activeBackground} !important;
                    }
                ` : ""}
            `,
            ...(P.hideFirstLast === "true" ? {
                arrowButtons: css`
                    background: transparent !important;
                    border: none !important;
                    padding: 0 !important;
                    min-height: unset !important;
                    ${P.pageColor ? `color: ${P.pageColor} !important;` : ""}
                    &:not(:disabled):hover {
                        background: transparent !important;
                        border: none !important;
                    }
                    &:disabled {
                        background: transparent !important;
                        border: none !important;
                        ${P.pageColor ? `color: ${P.pageColor} !important;` : ""}
                        ${P.arrowDisabledOpacity ? `opacity: ${P.arrowDisabledOpacity} !important;` : ""}
                    }
                `,
            } : {}),
            pagination: css`
                ${P.containerGap ? `gap: ${P.containerGap};` : ""}
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            margin-top: 20px;
                            flex-wrap: wrap;
                        `,
                        css`
                            margin-top: 20px;
                            flex-wrap: nowrap;
                        `,
                        css`
                            margin-top: 20px;
                            flex-wrap: nowrap;
                        `,
                        null,
                        null,
                    ])}
            `,
        },
    };
}
